<script setup>
    import { Link } from '@inertiajs/vue3'
    import { ref } from 'vue'
    import { usePage } from '@inertiajs/vue3'

    const currentYear = ref(new Date().getFullYear())
    const { props: propsPage } = usePage()
    const state = propsPage.state
    const statesShowDisclaimer = ['TX']
    const showDisclaimer = statesShowDisclaimer.includes(state)
</script>
<template>
    <div>
        <a href="https://x.com/fyfdotcom" target="_blank" class="inline-block">
            <font-awesome-icon
                :icon="['fab', 'x-twitter']"
                class="h-[25px] w-[25px] cursor-pointer text-lightgray hover:text-twitterblue dark:text-lightgray dark:hover:text-twitterblue" />
        </a>
    </div>
    <footer
        class="w-full pb-[40px] pt-[20px] text-left dark:bg-black dark:text-lightgray sm:pb-[70px] sm:pt-[20px]">
        <div class="space-x-4">
            <Link
                data-drawer-hide="right-navigation"
                :href="route('faq')"
                class="inline text-xs hover:underline"
                >FAQ</Link
            >
            <Link
                data-drawer-hide="right-navigation"
                :href="route('support')"
                class="inline text-xs hover:underline"
                >Support</Link
            >
            <Link
                data-drawer-hide="right-navigation"
                :href="route('tos')"
                class="inline text-xs hover:underline"
                >Terms of Service</Link
            >
            <Link
                data-drawer-hide="right-navigation"
                :href="route('privacy')"
                class="text-xs hover:underline"
                >Privacy Policy</Link
            >
            <Link
                data-drawer-hide="right-navigation"
                :href="route('creatorAgreement')"
                class="inline text-xs hover:underline"
                >Creator Agreement</Link
            >
        </div>

        <div class="mt-2 space-x-4">
            <a
                data-drawer-hide="right-navigation"
                href="https://www.epoch.com"
                class="inline text-xs hover:underline"
                target="_blank"
                >Epoch.com</a
            >
            <a
                data-drawer-hide="right-navigation"
                href="https://segpaycs.com/"
                class="inline text-xs hover:underline"
                target="_blank"
                >SegPay.com</a
            >
            <a
                data-drawer-hide="right-navigation"
                :href="route('dmca')"
                class="inline text-xs hover:underline"
                >DMCA</a
            >
            <a
                data-drawer-hide="right-navigation"
                :href="route('sitemap')"
                class="inline text-xs hover:underline"
                >Sitemap</a
            >
        </div>
        <div class="mt-2 space-x-4">
            <a
                data-drawer-hide="right-navigation"
                :href="route('content-removal')"
                class="inline text-xs hover:underline"
                >Content Removal</a
            >
            <a
                data-drawer-hide="right-navigation"
                :href="route('prohibitedContent')"
                class="inline text-xs hover:underline"
                >Prohibited Content</a
            >
        </div>

        <div class="mt-2">
            <Link
                data-drawer-hide="right-navigation"
                :href="route('compliance')"
                class="inline text-xs hover:underline"
                >18 USC 2257 Record-Keeping Requirements Compliance Statement</Link
            >
        </div>
        <div class="mt-2">
            <p class="block text-xs">
                <Link class="inline text-xs hover:underline" :href="route('complianceMastercard')">
                    Compliance with MasterCard Standards
                </Link>
            </p>
        </div>
        <div class="mt-2">
            <p class="block text-xs">©{{ currentYear }} Official Fans, Inc.</p>
        </div>

        <div class="mt-10">
            <Link
                :href="route('age-verify.create')"
                class="mb-2 me-2 rounded-full bg-gradient-to-b from-[#1a2942] to-[#0f1c2e] px-5 py-2.5 text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700"
                >AGE CHECK</Link
            >
        </div>
        <div v-if="showDisclaimer" class="mt-6">
            <h2 class="font-medium text-white">TEXAS HEALTH AND HUMAN SERVICES WARNING</h2>
            <ol class="">
                <li class="my-4">
                    U.S. SUBSTANCE ABUSE AND MENTAL HEALTH SERVICES ADMINISTRATION HELPLINE:
                </li>
                <li class="my-4">1-800-662-HELP (4357)</li>
                <li class="my-4">
                    THIS HELPLINE IS A FREE, CONFIDENTIAL INFORMATION SERVICE (IN ENGLISH OR
                    SPANISH) OPEN 24 HOURS PER DAY, FOR INDIVIDUALS AND FAMILY MEMBERS FACING MENTAL
                    HEALTH OR SUBSTANCE USE DISORDERS. THE SERVICE PROVIDES REFERRAL TO LOCAL
                    TREATMENT FACILITIES, SUPPORT GROUPS, AND COMMUNITY-BASED ORGANIZATIONS.
                </li>
            </ol>
        </div>
    </footer>
</template>
